import React, { useState } from "react";

const LetterToSanta = () => {
  const [showHelp, setShowHelp] = useState(false);

  return (
    <>
      <h5 className="pointer underline" onClick={() => setShowHelp(!showHelp)}>
        How it works?
      </h5>
      {showHelp && (
        <div className="padding-bottom-style">
          <p>
            Writing a letter to Santa is a fun Christmas tradition. A well
            written letter shows Santa you are polite. <br/> <b>Parent Mode:</b> First
            of all you need to add as many children as you want with the "Add
            Child" option. <br/> <b>Child Mode:</b> Then all of the children make
            their own list of gift that they want for Christmas!
          </p>
        </div>
      )}
    </>
  );
};

export default LetterToSanta;
